export class AppVersion {
    public static readonly Version = "1986(0ec35099)";
    public static readonly CommitHash = 'unknown';
}